import React from 'react';
import { useForm, useFieldArray } from 'react-hook-form';

const TimeFields = ({ control, index, register, errors }) => {
    const { fields: timeFields, append: appendTime, remove: removeTime } = useFieldArray({
        control,
        name: `timetable.${index}.time`,
    });

    return (
        <div className="time__items">
            {timeFields.map((timeItem, timeIndex) => (
                <div key={timeItem.id} className="time__item form__item">
                    <div >
                        <label>Время (00:00)</label>
                        <input
                            {...register(`timetable.${index}.time.${timeIndex}.time`,
                                { required: "Это поле обязательно" })}
                        />
                        {errors.timetable?.[index]?.time?.[timeIndex]?.time &&
                            <span>{errors.timetable[index].time[timeIndex].time.message}</span>}
                    </div>
                    <div>
                        <label>Цена (строка)</label>
                        <input
                            {...register(`timetable.${index}.time.${timeIndex}.price`,
                                { required: "Это поле обязательно" })}
                        />
                        {errors.timetable?.[index]?.time?.[timeIndex]?.price &&
                            <span>{errors.timetable[index].time[timeIndex].price.message}</span>}
                    </div>

                    <button type="button" onClick={() => removeTime(timeIndex)}>Удалить время</button>
                </div>
            ))}
            {/* Кнопка добавления времени */}
            <button type="button" onClick={() => appendTime({ time: '', price: '' })}>
                Добавить время
            </button>
        </div>
    );
};

export default TimeFields;